import React from 'react';

import ElementConstants from '../../../../shared/constants/elements';

import InputLabel from '../../widgets/input-label';
import InputHint from '../../widgets/input-hint';
import InputPlaceholder from '../../widgets/input-placeholder';
import Localization from '../../../../../../../common/edlio-js/models/BackendLocalization';

export default class PhoneNumberElement extends React.Component {

	render() {
		const {
			fieldsetIndex,
			rowIndex,
			index,
			usePlaceholderLabel
		} = this.props;

		const {
			label,
			hint,
			attributes,
			required
		} = this.props.data;

		let localization = new Localization(window.edlio.localizations);
		return (
      <div className="phone text input">
	      <header>
	        <InputLabel ref='label' label={label} required={required} usePlaceholderLabel={usePlaceholderLabel} />
	        <InputHint ref='hint' hint={hint} />
	      </header>
				<InputPlaceholder
					type={ElementConstants.INPUTS.PHONE}
					defaultValue={localization.localize('Phone')}
				/>
      </div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/components/form-elements/inputs/phone.js